import React from 'react';
import style from '../orderItemDetail.module.scss';
import cn from 'classnames';
import getDeviceType from '@utility/deviceType';

const IS_KIOSK = getDeviceType().isKiosk;

const TagList = React.memo(({ tags }) => {
  if (!tags || tags.length === 0) return null;
  return (
    <div
      className={cn('row justify-content-start mx-0 d-flex py-2')}
      style={{ gap: '8px' }}
    >
      {tags.map(tag => (
        <div
          key={tag.id ?? tag.shortName}
          className={cn(style.tagBox, IS_KIOSK && 'fs-10')}
        >
          {tag.display && (
            <>
              {tag.imageUrl ? (
                <div className={cn('h-100 w-100', style.tagwithiamge)}>
                  <img
                    src={tag.imageUrl}
                    alt={tag.shortName}
                    className={cn('h-100 w-100')}
                  />
                </div>
              ) : (
                tag.shortName && (
                  <div
                    className={cn(
                      style.tagTextBox,
                      'h-100 w-100 p-1 fs_12 text-center d-flex align-items-center justify-content-center'
                    )}
                    style={{ color: tag.color }}
                  >
                    {tag.shortName}
                  </div>
                )
              )}
            </>
          )}
        </div>
      ))}
    </div>
  );
});

export default TagList;
